// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    statusFrom: '',
    statusTo: '',
    interval: '',
};

const initialErrors = {
    statusFrom: '',
    statusTo: '',
    interval: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.selectedAutoStatus) {
            setValues({
                statusFrom: props.selectedAutoStatus.status_from.id.toString(),
                statusTo: props.selectedAutoStatus.status_to.id.toString(),
                interval: props.selectedAutoStatus.interval,
            });
        }
    }, [props.selectedAutoStatus]);

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/auto-statuses/${props.selectedAutoStatus.id}/`, {
            offer: props.selectedAutoStatus.offer.id,
            status_from: values.statusFrom,
            status_to: values.statusTo,
            interval: values.interval,
        }, abortController).then(({ok, data}) => {
            if (ok) {
                clear();
                props.onOk(data);
            }
            else {
                let _errors = {...initialErrors};
                _errors.statusFrom = (data.status_from) ? data.status_from[0] : '';
                _errors.statusTo = (data.status_to) ? data.status_to[0] : '';
                _errors.interval = (data.interval) ? data.interval[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        }).finally(() => {
            abortController = null;
        });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedAutoStatus(null);
    };

    return (
        <DialogForm title="Изменение автоматического статуса" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <Form values={values} setValues={setValues} errors={errors} setErrors={setErrors}/>
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedAutoStatus: PropTypes.object,
    setSelectedAutoStatus: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
